module.exports = __webpack_public_path__ + "fonts/RenaultLife-LightItalic.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/fonts/latin-basic/RenaultLife-LightItalic.svg
// module id = 366
// module chunks = 0